import { motion } from 'framer-motion';
import { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { Container } from './styles';

interface HeaderInterface {
  setEditCompanyModalShow: Dispatch<SetStateAction<boolean>>;
  setLockAccessModalShow: Dispatch<SetStateAction<boolean>>;
  setServicesModalShow: Dispatch<SetStateAction<boolean>>;
  isUnlocked: boolean;
  canShowServicesButton: boolean;
  canAccessFinancial: boolean;
}

interface CompaniesSelectOptions {
  label: string;
  options: {
      label: string;
      value: number;
      type: 'M' | 'F';
  }[];
}

export default function Header({
  setEditCompanyModalShow,
  setLockAccessModalShow,
  setServicesModalShow,
  isUnlocked,
  canShowServicesButton,
  canAccessFinancial,
}: HeaderInterface) {
  const { companyCode, companiesList, userProfile } = useGetGeneralAppData();

  const onlyOptions: {
    label: string;
    value: number;
    type: 'M' | 'F';
  }[][] = companiesList?.map((company: CompaniesSelectOptions) => (company.options));

  const flattedOptions = onlyOptions?.flat();

  const selectedCompanyType = flattedOptions?.find((company) => company.value === companyCode)?.type;

  const { permissions } = useGetGeneralAppData();
  const pagePermissions = permissions.find((x) => x.codPag === 1);
  const canEdit = pagePermissions?.alterar;

  const settingsPagePermissions = permissions.find((x) => x.codPag === 2);
  const canNavToSettings = settingsPagePermissions?.vizualizar;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: 0.1, type: 'tween', stiffness: 10 }}
      style={{ width: '100%' }}
    >
      <Container>
        <strong>
          Dados da empresa
        </strong>
        <div className="actionButtons">
          {canAccessFinancial && (
            <Link to="/company/financial">
              Financeiro
            </Link>
          )}
          {(canEdit) && (
            <button type="button" onClick={() => setEditCompanyModalShow(true)}>
              Editar
            </button>
          )}
          {selectedCompanyType === 'M' && (
            <Link to="/company/branches">
            Filiais
            </Link>
          )}
          {canNavToSettings && (
            <>
              <Link to="/company/settings">
                Configurações
              </Link>
              {/* <Link to={`/linesOperatorsExceptions/${companyCode}?type=cp&activeSidebar=Company&returnLink=${encodeURIComponent('/company')}`}>
                Exceções Operadoras e Linhas
              </Link>
              <Link to={`/linesOperatorsBias/${companyCode}?type=cp&activeSidebar=Company&returnLink=${encodeURIComponent('/company')}`}>
                Bias Operadoras e Linhas
              </Link> */}
            </>
          )}
          {(userProfile < 10 && canShowServicesButton) && (
            <>
              <button type="button" onClick={() => setServicesModalShow(true)}>
                Serviços
              </button>
              <button type="button" onClick={() => setLockAccessModalShow(true)}>
                {isUnlocked ? 'Bloquear Acesso' : 'Liberar Acesso'}
              </button>
            </>
          )}
        </div>
      </Container>
    </motion.div>
  );
}
